import { render, staticRenderFns } from "./PptBgAttr.vue?vue&type=template&id=2b43fdb7&"
import script from "./PptBgAttr.vue?vue&type=script&lang=js&"
export * from "./PptBgAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptBgAttr.vue"
export default component.exports